import React from "react"
import { ReactComponent as ArrowRight } from "app/assets/svg/arrow-right.svg"
import {
  StyledButton,
  StyledCard,
  StyledDescription,
  StyledTitle
} from "./style"

export interface ProductOptionProps {
  selected?: boolean
  title: string
  description: string
  cta?: string
  onClick: () => void
}

export const ProductOption: React.FC<ProductOptionProps> = ({
  title,
  description,
  cta,
  onClick,
  selected
}) => {
  return (
    <StyledCard onClick={onClick} selected={selected}>
      <StyledTitle>{title}</StyledTitle>
      <StyledDescription>{description}</StyledDescription>
      {cta && (
        <StyledButton
          icon={ArrowRight}
          iconPlacement="postfix"
          onClick={onClick}
          variant="plain"
        >
          {cta}
        </StyledButton>
      )}
    </StyledCard>
  )
}
